<div class="dialog-container no-padding-border-radius-dialog">
  <div class="ribbon-container">
    <img class="ribbon-img" src="/assets/image/star-redribbon.svg" />
    <div class="save-badge">
      <img class="badge-img" src="/assets/image/campaignBadge.gif" />
      <button class="close-btn" (click)="closeDialog()">✕</button>
    </div>
  </div>

  <div class="promo-content" >
    <h1 class="promo-title" style="text-align: left;">
      <span class="header" [innerHTML]="'common.EnjoyTenOffHeaderBanner' | translate"></span>
    </h1>
    
    <p class="promo-description" style="text-align: left;">
      <span class="body" [innerHTML]="'common.EnjoyTenOffBody' | translate"></span>
    </p>

    <div class="countdown-wrapper">
      <span class="offer-label">{{ cdTimerStartEndLabel | translate }}</span>
      <div class="timer-container">
        <div class="time-box">{{ cdTimerHours | number:'2.0' }}</div>
        <span class="separator">:</span>
        <div class="time-box">{{ cdTimerMinutes | number:'2.0' }}</div>
        <span class="separator">:</span>
        <div class="time-box">{{ cdTimerSeconds | number:'2.0' }}</div>
      </div>
    </div>
  </div>

</div>